import { css } from "@emotion/css";
import { Separator, Text } from "components";
import { CaretRightIcon } from "components/icons";
import { Link } from "react-router-dom";
import { E_Route } from "utils/constants";
import CalendarBg from "../assets/calendarCTA.png";

export const CalendarCTA = () => {
  return (
    <Link
      to={`${E_Route.Services}#calendar`}
      className={css`
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 20px 23px;
        border-radius: 16px;
        background: #1a191e;
        backdrop-filter: blur(1.5px);
        cursor: pointer;
        text-decoration: none;
        background-image: url(${CalendarBg});
        background-size: cover;
        background-position: center;
      `}
    >
      <div
        className={css`
          width: 90%;
          display: flex;
          flex-direction: column;
        `}
      >
        <Text.Body3XS color="highlight/1">CALENDAR INTEGRATION</Text.Body3XS>

        <Separator.Horizontal spacing={2} />
        <Text.Body>Get prepped for meetings</Text.Body>
        <Text.BodyXS>Info on attendees and companies</Text.BodyXS>
      </div>
      <div>
        <CaretRightIcon
          fill="primary"
          style={{
            width: "24px",
            height: "24px",
          }}
        />
      </div>
    </Link>
  );
};
